import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { practicalInformationApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeletePracticalInformation = (
  options?: UseMutationOptions<void, unknown, string>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-practical-information', assetId],
    async (practicalInformationId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await practicalInformationApi.practicalInformationControllerRemove(
        practicalInformationId,
        assetId
      );
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        queryClient.invalidateQueries('fetch-all-practical-information');
        // TODO: check if event had a date prop before invalidating events
        queryClient.invalidateQueries({ queryKey: ['fetch-events'] });
        trackEvent('PracticalInformation', 'delete');
        options?.onSettled?.(data, error, variables, context);
      },
    }
  );
};
